import { api } from '../api-client.config';
import { useMutation } from '@tanstack/react-query';

const exportUsersCsv = (contestId: number): Promise<Blob> =>
  api.get(`/contests/${contestId}/users/export-csv`);

export const useExportUsersCsv = (contestId: number) => {
  return useMutation({
    mutationKey: ['export-users-csv', contestId],
    mutationFn: () => exportUsersCsv(contestId),
  });
};
